import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body d-flex" }
const _hoisted_2 = { class: "me-2 flex-grow-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fw-boldest fs-3 mb-2" }, "Quick Start Project", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400 mb-7" }, "Earn $200 bonus now", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end align-items-end w-75px me-n5 me-lg-n10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/illustrations/dozzy-1/3.png",
    class: "h-125px h-lg-150px",
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: _normalizeClass([`btn-${_ctx.currentColor}`, "btn btn-sm"]),
          "data-bs-toggle": "modal",
          "data-bs-target": "#kt_modal_create_account"
        }, "Quick Start", 2)
      ]),
      _hoisted_5
    ])
  ], 2))
}